import React from "react";
import {useTranslation} from "react-i18next";
import "./style.scss";
import ReserveDetail from "../ReserveDetail";

const AgendamientoAppointment = ({
  appointmentsDetails,
  menuHandler,
  linkHandler,
}) => {
  const {t} = useTranslation();
  let iconClass = "no-appointment";
  if (
    !appointmentsDetails.existingBookingDetails ||
    appointmentsDetails.existingBookingDetails[0]?.length === 0
  ) {
    return (
      <div className="no-bookings-page">
        <div className={iconClass}></div>
        <div className="no-bookings-header no-bookings-text">
          {t("displayAppointment.title")}
        </div>
        <div className="no-bookings-text">{t("emptyReservations")}</div>
      </div>
    );
  }
  const appointmentsByDay = appointmentsDetails.existingBookingDetails;
  const appointments = appointmentsByDay
    .flatMap((a) => Object.values(a))
    .flat();
  return (
    <>
      {appointments.length > 0 ? (
        <label className="heading displayBlock">
          {t("displayAppointment.title")}
        </label>
      ) : (
        ""
      )}
      <div className="add-scroll">
        {appointments.map((appointment, index) => (
          <ReserveDetail
            data={appointment}
            key={index}
            cancel={() => menuHandler(appointment)}
            getDetail={() => linkHandler(appointment)}
          />
        ))}
      </div>
    </>
  );
};

export default AgendamientoAppointment;
